import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ThemeService} from "@ui-webkit/styles/themes/theme.service";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ProcessingDialogComponent} from "@ui-webkit/components/processing-dialog/processing-dialog.component";
import {MatCard, MatCardContent} from "@angular/material/card";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatProgressSpinner, ProcessingDialogComponent, MatCard, MatCardContent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'admin-portal';
  isLoading = true;

  constructor(private themeService: ThemeService) {
  }

  ngOnInit(): void {
    //Note: this timeout is just to simulate the app loading from the server. Do not add this in client apps.
    setTimeout(() => {
      this.isLoading = false;
    }, 2000); // Adjust the timeout as needed


    this.themeService.initializeTheme();
  }
}
